<template>
    <RouterLink
        v-for="navLink in navLinks"
        :key="navLink.route"
        v-slot="{ navigate, isActive }"
        :to="{ name: navLink.route }"
        custom
    >
        <div
            class="cursor-pointer"
            :class="{'hover-effect': !isActive && !getIsActive(navLink)}"
            @click="navigate(); navLink.action ? navLink.action() : null"
        >
            <a
                :data-tour="navLink.dataTour"
                :data-cy="navLink.dataCy ?? undefined"
                class="flex px-3 lg:px-0 xl:px-3 py-2 text-sm font-medium text-gray-500 whitespace-nowrap
                    hover:bg-gray-100 lg:hover:text-gray-900 lg:hover:bg-white"
                :class="{
                    'text-gray-800 lg:text-gray-900 lg:border-b-[3px] lg:border-halo-gold': isActive || getIsActive(navLink)
                }"
                aria-current="page"
            >
                <Component
                    :is="navLink.icon"
                    class="w-5 h-5 text-halo-gold mr-1 xl:mr-2"
                    :class="navLink.iconClass"
                ></Component>

                <span>{{ navLink.label }}</span>
            </a>
        </div>
    </RouterLink>
</template>

<script setup lang="ts">
import { NavigationLink } from '@/types';
import { RouterLink, useRoute } from 'vue-router';

defineProps<{
    navLinks: NavigationLink[]
}>();

const route = useRoute();

const getIsActive = (navLink: NavigationLink) => {
    if (navLink.matches) {
        return navLink.matches.find((value) => {
            return route.path.includes(value);
        });
    }
    return false;
};
</script>
